import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import LazyImage from './LazyImage';

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 80vh;
  min-height: 500px;
  overflow: hidden;
  background: #000;
`;

const Slide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition: opacity 1s ease-in-out;
  z-index: 1;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 1rem;
  z-index: 2;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSlider = ({ images, text }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!images || images.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) {
    return (
      <SliderContainer>
         <Overlay>
            <Title>{text}</Title>
         </Overlay>
      </SliderContainer>
    );
  }

  return (
    <SliderContainer>
      {images.map((img, index) => (
        <Slide key={index} $active={index === current}>
          <LazyImage src={img} alt={`Slide ${index}`} />
        </Slide>
      ))}
      <Overlay>
        <Title>{text}</Title>
      </Overlay>
    </SliderContainer>
  );
};

export default HeroSlider;
